import { PanelLeft } from 'lucide-react';
import styled from 'styled-components';

import { CenterFlex } from '@/components/base';
import { cn } from '@/lib/cn';

type Props = {
  shrinked: boolean;
  onClick: () => void;
};

const SidebarToggleButton = (props: Props) => {
  return (
    <SidebarToggleButtonStyle
      a="center"
      padding="8px"
      style={{ cursor: 'pointer' }}
      onClick={props.onClick}
    >
      <PanelLeft
        className={cn(
          'text-foreground size-4 transition-transform duration-200 ease-out',
          props.shrinked && 'rotate-180',
        )}
      />
    </SidebarToggleButtonStyle>
  );
};

export default SidebarToggleButton;

const SidebarToggleButtonStyle = styled(CenterFlex)`
  border-radius: 8px;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${(props) => props.theme.colors.sidebar_accent};
  }
`;
